import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { colorSet } from '@components/Provider';

export interface ReviewCardProps {
  title: React.ReactNode;
  companyName: string;
  review: React.ReactNode;
  writer: string;
}
const ReviewCard: React.FC<ReviewCardProps> = ({
  title,
  companyName,
  review,
  writer,
  ...rest
}) => {
  const { cardContainer, companyNameBox, reviewBox, writerBox } = useStyles();

  return (
    <Box className={cardContainer} {...rest}>
      <Box className={companyNameBox}>{title}</Box>
      <Box className={reviewBox}>{review}</Box>
      <Box className={writerBox}>
        {companyName} - <p>{writer}</p>
      </Box>
    </Box>
  );
};

export default ReviewCard;

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 16,
    gap: '16px',
    padding: '30px 20px 24px',
    backgroundColor: colorSet.gray100,
    minWidth: 304,
    width: 304,
    minHeight: 367,
    height: 367,
    [theme.breakpoints.down('md')]: {
      minWidth: 285,
      width: 285,
      minHeight: 376,
      height: 376
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minHeight: 100,
      borderRadius: 16,
      boxShadow: 'none',
      height: 'auto'
    }
  },
  reviewBox: {
    height: 210,
    '& p': {
      lineHeight: '180%',
      wordBreak: 'break-word',
      '& > b': {
        fontWeight: '700',
        color: colorSet.gray900
      }
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto'
    }
  },
  companyNameBox: {
    display: 'flex',
    gap: '12px'
  },
  writerBox: {
    marginTop: '9px',
    fontWeight: 500,
    textAlign: 'right',
    '& p': {
      display: 'inline-block',
      margin: 0,
      color: colorSet.primary500
    }
  }
}));
